export interface Offer {
  cities: string[]
  id: string
  message: string
}

export interface CityOffer {
  cityName: string
  offers: Offer[]
}

export const DRIVER_OFFERS: Offer[] = [
  /*
  * Commenting out the offers for now as we are not using them yet
   {
    cities: ['Sudbury', 'North Bay', 'Nanaimo', 'Kamloops'],
    id: 'offer-1',
    message: 'Earn a minimum of $10K in 5 weeks* by driving with Uride!',
  },
  {
    cities: [
      'Chatham-Kent',
      'Timmins',
      'Grande Prairie',
      'Peterborough',
      'Belleville',
      'Kelowna',
      'Charlottetown',
      'Fredericton',
      'Moncton',
      'Saint John',
    ],
    id: 'offer-2',
    message: 'Earn a minimum of $10K in 6 weeks by driving with Uride!',
  }, */
  {
    cities: ['Kamloops', 'Nanaimo'],
    id: 'offer-3',
    message:
      'Drive with Uride and earn $250 for completing 10 rides in 7 days.',
  },
  /* {
    cities: [
      'Penticton',
      'Vernon',
      'Courtenay/Comox',
      'Prince George',
      'Medicine Hat',
      'Grande Prairie',
      'Charlottetown',
      'Saint John',
    ],
    id: 'offer-4',
    message: '$500 for completing 100 trips in 30 days',
  }, */
  {
    cities: ['Kamloops', 'Nanaimo'],
    id: 'offer-5',
    message: '$1000 for completing 100 trips in 30 days',
  },
]

/**
 * Check if a city is Canadian based on country ID
 * @param cityName - The name of the city
 * @param countryId - The country ID of the selected country
 * @returns boolean indicating if the city is Canadian
 */
export const isCanadianCity = (
  cityName: string,
  countryId?: number
): boolean => {
  if (!cityName) return false

  // Check if country ID is 1 (Canada)
  return countryId === 1
}

/**
 * Get offers for a specific city (Canadian cities only)
 * @param cityName - The name of the city
 * @param countryId - The country ID of the selected country
 * @returns Array of offers applicable to the city
 */
export const getOffersForCity = (
  cityName: string,
  countryId?: number
): Offer[] => {
  if (!cityName) return []

  // Only show offers for Canadian cities (country ID = 1)
  if (!isCanadianCity(cityName, countryId)) return []

  // Get specific offers for the city
  const specificOffers = DRIVER_OFFERS.filter((offer) =>
    offer.cities.some((city) => city.toLowerCase() === cityName.toLowerCase())
  )

  // Get the general Canadian offer (All Canadian Cities)
  const generalOffers = DRIVER_OFFERS.filter((offer) =>
    offer.cities.includes('All Canadian Cities')
  )

  return [...specificOffers, ...generalOffers]
}

/**
 * Get all unique Canadian cities that have offers
 * @returns Array of Canadian city names with offers
 */
export const getCitiesWithOffers = (): string[] => {
  const cities = new Set<string>()

  DRIVER_OFFERS.forEach((offer) => {
    if (offer.cities.includes('All Canadian Cities')) {
      // For "All Canadian Cities" offers, we don't add specific cities
      return
    }
    offer.cities.forEach((city) => cities.add(city))
  })

  return Array.from(cities).sort()
}
